{
    "coordinates": [
        28.862668964316043,
        28.368058662925122
    ],
    "tooltip": "Bahariya",
    "title": "Bahariya Formation",
    "country": "Egypt",
    "period": "Cretaceous",
    "alt": "TODO"
}
